(function () {
  function initHowHeroParallax(root) {
    var heroes = (root || document).querySelectorAll('.ohow-hero');
    if (!heroes.length && root && root.matches && root.matches('.ohow-hero')) heroes = [root];

    Array.prototype.forEach.call(heroes, function (hero) {
      if (!hero || hero.dataset.ohowHeroParallaxReady === 'true') return;
      hero.dataset.ohowHeroParallaxReady = 'true';

      var media = hero.querySelector('.ohow-hero__media');
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var ticking = false;

      if (!media) return;

      function update() {
        var scrollY = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
        var heroHeight = Math.max(1, hero.offsetHeight || window.innerHeight || 1);
        var progress = Math.min(1, scrollY / heroHeight);
        var isPastHero = scrollY >= heroHeight - 1;

        hero.classList.toggle('is-past-hero', isPastHero);
        if (!reduceMotion) {
          var offset = Math.round(progress * -44);
          var scale = (1 + progress * 0.035).toFixed(4);
          var overlay = (progress * 0.5).toFixed(4);

          media.style.setProperty('--ohow-hero-parallax-y', offset + 'px');
          media.style.setProperty('--ohow-hero-parallax-scale', scale);
          media.style.setProperty('--ohow-hero-overlay', overlay);
        }
        ticking = false;
      }

      function requestUpdate() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      update();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
    });
  }

  function initHowNav(root) {
    var navs = (root || document).querySelectorAll('[data-ohow-page-nav]');
    if (!navs.length && root && root.matches && root.matches('[data-ohow-page-nav]')) navs = [root];

    Array.prototype.forEach.call(navs, function (section) {
      if (!section || section.dataset.ohowNavReady === 'true') return;
      section.dataset.ohowNavReady = 'true';

      var headerWrapper = document.querySelector('.header-wrapper');
      var links = section.querySelectorAll('[data-ohow-nav-link]');
      var hiddenClass = 'odyss-header--hidden';
      var stuckClass = 'is-stuck';
      var activeClass = 'is-active';
      var hiddenForOverlayClass = 'is-hidden-for-overlay';
      var mobileMenuToggle = document.querySelector('.js-toggle-slide-nav');
      var bodyEl = document.body;
      var topThreshold = 16;
      var directionThreshold = 8;
      var prevScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var placeholder = document.createElement('div');
      var triggerY = 0;
      var targets = [];
      var activeLink = null;
      var ticking = false;

      var toggleBtn = section.querySelector('[data-ohow-nav-toggle]');
      var linksContainer = section.querySelector('.ohow-anchor-nav__links');
      var subscribeLink = section.querySelector('[data-ohow-subscribe-link]');

      placeholder.setAttribute('data-ohow-nav-placeholder', '');
      section.parentNode.insertBefore(placeholder, section.nextSibling);

      function getVisibleHeaderHeight() {
        return headerWrapper && !headerWrapper.classList.contains(hiddenClass) ? headerWrapper.offsetHeight : 0;
      }

      function getSpyOffset() {
        return getVisibleHeaderHeight() + (section.offsetHeight || 60) + 24;
      }

      function isOverlayOpen() {
        if (bodyEl.classList.contains('screen-layer-open') ||
            bodyEl.classList.contains('screen-layer-closing') ||
            bodyEl.classList.contains('screen-layer-animating')) return true;
        if (document.documentElement.classList.contains('js-drawer-open')) return true;
        if (mobileMenuToggle && mobileMenuToggle.classList.contains('is-active')) return true;
        return false;
      }

      function measure() {
        if (isOverlayOpen()) return;
        var wasStuck = section.classList.contains(stuckClass);
        if (wasStuck) {
          section.classList.remove(stuckClass);
          placeholder.style.display = 'none';
        }
        var h = section.offsetHeight;
        if (h > 0) {
          placeholder.style.height = h + 'px';
          triggerY = Math.round(section.getBoundingClientRect().top + (window.pageYOffset || 0));
        }
        if (wasStuck) {
          section.classList.add(stuckClass);
          placeholder.style.display = 'block';
        }
      }

      function refreshTargets() {
        targets = [];
        Array.prototype.forEach.call(links, function (link) {
          var id = link.getAttribute('data-anchor-id');
          var el = id && document.getElementById(id);
          if (el) targets.push({ link: link, el: el });
        });
      }

      // 控制在移动端滚动时或切换时激活哪一个链接
      function setActive(link) {
        if (!link || link === activeLink) return;
        activeLink = link;
        Array.prototype.forEach.call(links, function (item) {
          var isActive = item === link;
          item.classList.toggle(activeClass, isActive);
          if (isActive) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
      }

      function updateActiveByScroll() {
        if (!targets.length) return;
        var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        var probeY = scrollY + getSpyOffset();
        var current = targets[0].link;
        for (var i = 0; i < targets.length; i++) {
          var targetTop = targets[i].el.getBoundingClientRect().top + scrollY;
          if (targetTop <= probeY) current = targets[i].link;
          else break;
        }
        setActive(current);
      }

      function updateStuck() {
        if (isOverlayOpen()) return;
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        var shouldStick = y >= triggerY;
        section.classList.toggle(stuckClass, shouldStick);
        placeholder.style.display = shouldStick ? 'block' : 'none';
      }

      function refresh() {
        measure();
        refreshTargets();
        updateStuck();
        updateActiveByScroll();
      }

      function applyOverlayState() {
        if (isOverlayOpen()) {
          section.classList.add(hiddenForOverlayClass);
          section.classList.remove(stuckClass);
          placeholder.style.display = 'none';
        } else {
          section.classList.remove(hiddenForOverlayClass);
          window.requestAnimationFrame(refresh);
        }
      }

      // 绑定 Toggle 按钮点击事件，切换抽屉状态
      if (toggleBtn && linksContainer) {
        toggleBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          var expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
          toggleBtn.setAttribute('aria-expanded', !expanded ? 'true' : 'false');
          linksContainer.classList.toggle('is-open', !expanded);
        });

        // 页面空白处点击时收起抽屉
        document.addEventListener('click', function (event) {
          if (!section.contains(event.target)) {
            toggleBtn.setAttribute('aria-expanded', 'false');
            linksContainer.classList.remove('is-open');
          }
        });
      }

      Array.prototype.forEach.call(links, function (link) {
        link.addEventListener('click', function (event) {
          var id = link.getAttribute('data-anchor-id');
          var target = id && document.getElementById(id);
          if (!target) return;
          event.preventDefault();
          var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
          var top = target.getBoundingClientRect().top + scrollY - getSpyOffset() + 10;
          setActive(link);
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          if (history.pushState) history.pushState(null, '', '#' + id);

          // 点击链接后，自动收起抽屉面板
          if (toggleBtn && linksContainer) {
            toggleBtn.setAttribute('aria-expanded', 'false');
            linksContainer.classList.remove('is-open');
          }
        });
      });

      if (subscribeLink) {
        subscribeLink.addEventListener('click', function (event) {
          var id = subscribeLink.getAttribute('data-anchor-id');
          var target = id && document.getElementById(id);
          if (!target) return;
          event.preventDefault();
          var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
          var top = target.getBoundingClientRect().top + scrollY - getSpyOffset() + 10;
          var form = target.querySelector('.opre-klaviyo-form');
          if (form) {
            // Keep the email field and submit button visible below the section heading.
            var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
            var formBottom = form.getBoundingClientRect().bottom + scrollY;
            top = Math.max(top, formBottom - viewportHeight + 48);
          }
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          if (history.pushState) history.pushState(null, '', '#' + id);
          if (toggleBtn && linksContainer) {
            toggleBtn.setAttribute('aria-expanded', 'false');
            linksContainer.classList.remove('is-open');
          }
        });
      }

      if (headerWrapper && 'MutationObserver' in window) {
        new MutationObserver(function () {
          updateStuck();
          updateActiveByScroll();
        }).observe(headerWrapper, { attributes: true, attributeFilter: ['class'] });
      }

      if ('MutationObserver' in window) {
        var bodyObserver = new MutationObserver(applyOverlayState);
        bodyObserver.observe(bodyEl, { attributes: true, attributeFilter: ['class'] });
        bodyObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
        if (mobileMenuToggle) bodyObserver.observe(mobileMenuToggle, { attributes: true, attributeFilter: ['class'] });
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var y = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
          var delta = y - prevScrollY;
          updateStuck();
          if (isOverlayOpen() || y <= topThreshold) {
            if (headerWrapper) headerWrapper.classList.remove(hiddenClass);
          } else if (delta > directionThreshold) {
            if (headerWrapper) headerWrapper.classList.add(hiddenClass);
          } else if (delta < -directionThreshold) {
            if (headerWrapper) headerWrapper.classList.remove(hiddenClass);
          }
          updateActiveByScroll();
          prevScrollY = y;
          ticking = false;
        });
      }

      refresh();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', refresh);
      document.addEventListener('shopify:section:load', function (event) {
        initHowNav(event.target);
      });
    });
  }

  function initHowSteps(root) {
    var tablists = (root || document).querySelectorAll('[data-ohow-step-tabs]');
    if (!tablists.length && root && root.matches && root.matches('[data-ohow-step-tabs]')) tablists = [root];

    Array.prototype.forEach.call(tablists, function (tablist) {
      if (!tablist || tablist.dataset.ohowStepsReady === 'true') return;
      tablist.dataset.ohowStepsReady = 'true';

      var section = tablist.closest('.ohow-intro');
      var tabs = tablist.querySelectorAll('[data-ohow-step-tab]');
      var indicator = tablist.querySelector('[data-ohow-step-indicator]');
      var tabsShell = tablist.closest('[data-ohow-step-tabs-shell]');
      var tabScrollControl = tabsShell ? tabsShell.querySelector('[data-ohow-step-tabs-next]') : null;
      var mediaStage = section ? section.querySelector('[data-ohow-step-media-stage]') : null;
      var media = section ? section.querySelectorAll('[data-ohow-step-media]') : [];
      var descriptions = section ? section.querySelectorAll('[data-ohow-step-description]') : [];
      var controls = section ? section.querySelectorAll('[data-ohow-step-control]') : [];
      var activeIndex = 0;
      var descriptionEnterTimer = null;
      var scrollTicking = false;
      var isProgrammaticMediaScroll = false;
      var programmaticMediaScrollTimer = null;
      var isDraggingMedia = false;
      var mediaDragStartX = 0;
      var mediaDragStartScrollLeft = 0;
      var descriptionExitDelay = 260;

      function getWrappedIndex(index) {
        if (!tabs.length) return 0;
        return (index + tabs.length) % tabs.length;
      }

      function isMobileLayout() {
        return window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
      }

      function prepareVideo(video, panel) {
        video.muted = true;
        video.defaultMuted = true;
        video.volume = 0;
        video.loop = false;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.removeAttribute('loop');
        video.removeAttribute('controls');
        if (video.dataset.ohowStepVideoReady === 'true') return;
        video.dataset.ohowStepVideoReady = 'true';
        video.addEventListener('ended', function () {
          if (!panel || !panel.classList.contains('is-active')) return;
          if (video.getClientRects && !video.getClientRects().length) return;
          setActive(getWrappedIndex(activeIndex + 1), {
            scrollMedia: false,
            scrollTab: false
          });
        });
      }

      function updateVideoPlayback(restartActive) {
        Array.prototype.forEach.call(media, function (panel) {
          var isActive = panel.classList.contains('is-active');
          Array.prototype.forEach.call(panel.querySelectorAll('video'), function (video) {
            var isVisible = !video.getClientRects || video.getClientRects().length > 0;
            prepareVideo(video, panel);
            if (isActive && isVisible) {
              if (restartActive) {
                try {
                  video.currentTime = 0;
                } catch (error) {}
              }
              var promise = video.play();
              if (promise && typeof promise.catch === 'function') promise.catch(function () {});
            } else {
              video.pause();
            }
          });
        });
      }

      function moveIndicator(index) {
        if (!indicator) return;
        tablist.setAttribute('data-active-index', index);
      }

      function updateTabScrollControl() {
        if (!tabScrollControl || !tabsShell) return;
        var showControl = isMobileLayout();
        tabScrollControl.hidden = !showControl;
        tabsShell.classList.toggle('is-tab-overflowing', showControl);
      }

      function beginProgrammaticMediaScroll() {
        isProgrammaticMediaScroll = true;
        if (programmaticMediaScrollTimer) window.clearTimeout(programmaticMediaScrollTimer);
        programmaticMediaScrollTimer = window.setTimeout(function () {
          isProgrammaticMediaScroll = false;
          programmaticMediaScrollTimer = null;
        }, 520);
      }

      function endProgrammaticMediaScroll() {
        isProgrammaticMediaScroll = false;
        if (programmaticMediaScrollTimer) window.clearTimeout(programmaticMediaScrollTimer);
        programmaticMediaScrollTimer = null;
      }

      function scrollActiveMediaIntoView(index) {
        if (!isMobileLayout() || !media[index] || typeof media[index].scrollIntoView !== 'function') return;
        beginProgrammaticMediaScroll();
        media[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      function updateDescriptions(index, immediate) {
        if (descriptionEnterTimer) window.clearTimeout(descriptionEnterTimer);
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (immediate || reduceMotion) {
          Array.prototype.forEach.call(descriptions, function (description) {
            var isActive = Number(description.getAttribute('data-ohow-step-description')) === index;
            description.classList.toggle('is-active', isActive);
            description.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          });
          return;
        }

        Array.prototype.forEach.call(descriptions, function (description) {
          description.classList.remove('is-active');
          description.setAttribute('aria-hidden', 'true');
        });

        descriptionEnterTimer = window.setTimeout(function () {
          Array.prototype.forEach.call(descriptions, function (description) {
            var isActive = Number(description.getAttribute('data-ohow-step-description')) === index;
            description.classList.toggle('is-active', isActive);
            description.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          });
          descriptionEnterTimer = null;
        }, descriptionExitDelay);
      }

      function setActive(index, options) {
        options = options || {};
        var isSameIndex = activeIndex === index;
        activeIndex = index;
        Array.prototype.forEach.call(tabs, function (tab) {
          var isActive = Number(tab.getAttribute('data-ohow-step-tab')) === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });
        moveIndicator(index);
        Array.prototype.forEach.call(media, function (panel) {
          var isActive = Number(panel.getAttribute('data-ohow-step-media')) === index;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        updateDescriptions(index, isSameIndex || options.transitionDescription === false);
        Array.prototype.forEach.call(controls, function (control) {
          var direction = control.getAttribute('data-ohow-step-control');
          control.disabled = direction === 'prev' ? index <= 0 : index >= tabs.length - 1;
        });
        if (options.scrollMedia !== false) scrollActiveMediaIntoView(index);
        updateVideoPlayback(options.restartVideo !== false);
      }

      function syncActiveFromMediaScroll() {
        scrollTicking = false;
        if (isProgrammaticMediaScroll || !isMobileLayout() || !mediaStage || !media.length) return;

        var stageRect = mediaStage.getBoundingClientRect();
        var stageCenter = stageRect.left + stageRect.width / 2;
        var closestIndex = activeIndex;
        var closestDistance = Infinity;

        Array.prototype.forEach.call(media, function (panel) {
          var panelRect = panel.getBoundingClientRect();
          var panelIndex = Number(panel.getAttribute('data-ohow-step-media')) || 0;
          var panelCenter = panelRect.left + panelRect.width / 2;
          var distance = Math.abs(stageCenter - panelCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = panelIndex;
          }
        });

        if (closestIndex !== activeIndex) {
          setActive(closestIndex, { scrollMedia: false, scrollTab: false, restartVideo: false });
        }
      }

      function requestMediaScrollSync() {
        if (scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(syncActiveFromMediaScroll);
      }

      function stopMediaDrag(event) {
        if (!isDraggingMedia || !mediaStage) return;
        isDraggingMedia = false;
        mediaStage.classList.remove('is-dragging');
        if (event && mediaStage.hasPointerCapture && mediaStage.hasPointerCapture(event.pointerId)) {
          mediaStage.releasePointerCapture(event.pointerId);
        }
      }

      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          setActive(Number(tab.getAttribute('data-ohow-step-tab')) || 0);
        });
        tab.addEventListener('keydown', function (event) {
          var nextIndex = activeIndex;
          if (event.key === 'ArrowRight') nextIndex = Math.min(tabs.length - 1, activeIndex + 1);
          else if (event.key === 'ArrowLeft') nextIndex = Math.max(0, activeIndex - 1);
          else return;
          event.preventDefault();
          setActive(nextIndex);
          if (tabs[nextIndex]) tabs[nextIndex].focus();
        });
      });

      Array.prototype.forEach.call(controls, function (control) {
        control.addEventListener('click', function () {
          var direction = control.getAttribute('data-ohow-step-control');
          var nextIndex = direction === 'prev' ? activeIndex - 1 : activeIndex + 1;
          nextIndex = Math.max(0, Math.min(tabs.length - 1, nextIndex));
          setActive(nextIndex);
        });
      });

      if (tabScrollControl) {
        tabScrollControl.addEventListener('click', function () {
          setActive(getWrappedIndex(activeIndex + 1));
        });
      }

      if (mediaStage) {
        mediaStage.addEventListener('pointerdown', function (event) {
          if (!isMobileLayout()) return;
          if (event.button !== 0 && event.pointerType === 'mouse') return;
          endProgrammaticMediaScroll();
          isDraggingMedia = true;
          mediaDragStartX = event.clientX;
          mediaDragStartScrollLeft = mediaStage.scrollLeft;
          mediaStage.classList.add('is-dragging');
          mediaStage.setPointerCapture(event.pointerId);
        });

        mediaStage.addEventListener('pointermove', function (event) {
          if (!isDraggingMedia || !mediaStage) return;
          event.preventDefault();
          mediaStage.scrollLeft = mediaDragStartScrollLeft - (event.clientX - mediaDragStartX);
        });

        mediaStage.addEventListener('pointerup', stopMediaDrag);
        mediaStage.addEventListener('pointercancel', stopMediaDrag);
        mediaStage.addEventListener('pointerleave', stopMediaDrag);
        mediaStage.addEventListener('scroll', requestMediaScrollSync, { passive: true });
        mediaStage.addEventListener('scrollend', endProgrammaticMediaScroll);
      }

      var activeTab = tablist.querySelector('[data-ohow-step-tab].is-active') || tabs[0];
      if (activeTab) {
        setActive(Number(activeTab.getAttribute('data-ohow-step-tab')) || 0, {
          scrollMedia: false,
          scrollTab: false,
          transitionDescription: false
        });
      }
      window.addEventListener('resize', function () {
        moveIndicator(activeIndex);
        updateTabScrollControl();
      });
      updateTabScrollControl();
    });
  }

  function initHowInsightScroll(root) {
    var scrollers = (root || document).querySelectorAll('.ohow-insights__grid');
    if (!scrollers.length && root && root.matches && root.matches('.ohow-insights__grid')) scrollers = [root];

    Array.prototype.forEach.call(scrollers, function (scroller) {
      if (!scroller || scroller.dataset.ohowInsightScrollReady === 'true') return;
      scroller.dataset.ohowInsightScrollReady = 'true';

      var isDragging = false;
      var startX = 0;
      var startScrollLeft = 0;
      var section = scroller.closest ? scroller.closest('.ohow-insights') : null;
      var controls = section ? section.querySelectorAll('[data-ohow-insights-control]') : [];
      var prevControl = section ? section.querySelector('[data-ohow-insights-control="prev"]') : null;
      var nextControl = section ? section.querySelector('[data-ohow-insights-control="next"]') : null;
      var ticking = false;

      function getScrollStep() {
        var card = scroller.querySelector('.ohow-insight-card');
        if (!card) return Math.max(1, Math.round(scroller.clientWidth * 0.8));
        var styles = window.getComputedStyle ? window.getComputedStyle(scroller) : null;
        var gap = styles ? parseFloat(styles.columnGap || styles.gap || '0') || 0 : 0;
        return Math.max(1, Math.round(card.getBoundingClientRect().width + gap));
      }

      function updateControls() {
        var maxScrollLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        var atStart = scroller.scrollLeft <= 1;
        var atEnd = scroller.scrollLeft >= maxScrollLeft - 1;

        if (prevControl) prevControl.disabled = atStart;
        if (nextControl) nextControl.disabled = atEnd;
        ticking = false;
      }

      function requestControlsUpdate() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateControls);
      }

      function scrollByDirection(direction) {
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        scroller.scrollBy({
          left: getScrollStep() * direction,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }

      Array.prototype.forEach.call(controls, function (control) {
        control.addEventListener('click', function () {
          if (control.disabled) return;
          scrollByDirection(control.getAttribute('data-ohow-insights-control') === 'prev' ? -1 : 1);
        });
      });

      scroller.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse') return;
        if (event.button !== 0) return;
        isDragging = true;
        startX = event.clientX;
        startScrollLeft = scroller.scrollLeft;
        scroller.classList.add('is-dragging');
        scroller.setPointerCapture(event.pointerId);
      });

      scroller.addEventListener('pointermove', function (event) {
        if (!isDragging) return;
        event.preventDefault();
        scroller.scrollLeft = startScrollLeft - (event.clientX - startX);
      });

      function stopDragging(event) {
        if (!isDragging) return;
        isDragging = false;
        scroller.classList.remove('is-dragging');
        if (event && scroller.hasPointerCapture && scroller.hasPointerCapture(event.pointerId)) {
          scroller.releasePointerCapture(event.pointerId);
        }
      }

      scroller.addEventListener('pointerup', stopDragging);
      scroller.addEventListener('pointercancel', stopDragging);
      scroller.addEventListener('pointerleave', stopDragging);
      scroller.addEventListener('scroll', requestControlsUpdate, { passive: true });
      window.addEventListener('resize', requestControlsUpdate);
      updateControls();
    });
  }

  function initHowInsightModal(root) {
    var sections = (root || document).querySelectorAll('.ohow-insights');
    if (!sections.length && root && root.matches && root.matches('.ohow-insights')) sections = [root];

    Array.prototype.forEach.call(sections, function (section) {
      if (!section || section.dataset.ohowInsightModalReady === 'true') return;
      section.dataset.ohowInsightModalReady = 'true';

      var layer = section.querySelector('[data-ohow-insight-modal-layer]');
      var triggers = section.querySelectorAll('[data-ohow-insight-modal-trigger]');
      var modal = layer ? layer.querySelector('[data-ohow-insight-modal]') : null;
      var modalMedia = modal ? modal.querySelector('[data-ohow-insight-modal-media]') : null;
      var modalCopy = modal ? modal.querySelector('[data-ohow-insight-modal-copy]') : null;
      var activeModal = null;
      var activeTrigger = null;
      var lockedScrollY = 0;

      if (!layer || !modal || !modalMedia || !modalCopy || !triggers.length) return;

      function ensureLayerInBody() {
        if (layer.parentNode !== document.body) {
          document.body.appendChild(layer);
        }
      }

      function lockPageScroll() {
        lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        document.documentElement.classList.add('ohow-modal-open');
        document.body.classList.add('ohow-modal-open');
        document.body.style.top = '-' + lockedScrollY + 'px';
      }

      function unlockPageScroll() {
        document.documentElement.classList.remove('ohow-modal-open');
        document.body.classList.remove('ohow-modal-open');
        document.body.style.top = '';
        window.scrollTo(0, lockedScrollY);
      }

      function getFocusable(modal) {
        if (!modal) return [];
        return Array.prototype.slice.call(modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
          .filter(function (el) {
            return !el.disabled && el.offsetParent !== null;
          });
      }

      function getConfig(key) {
        var configs = section.querySelectorAll('[data-ohow-insight-modal-config]');
        for (var i = 0; i < configs.length; i++) {
          if (configs[i].getAttribute('data-ohow-insight-modal-config') === key) return configs[i];
        }
        return null;
      }

      function renderModal(key) {
        var config = getConfig(key);
        if (!config || !config.content) return false;

        var media = config.content.querySelector('[data-ohow-insight-modal-config-media]');
        var copy = config.content.querySelector('[data-ohow-insight-modal-config-copy]');
        if (!media || !copy) return false;

        modalMedia.innerHTML = media.innerHTML;
        modalCopy.innerHTML = copy.innerHTML;
        return true;
      }

      function closeModal() {
        if (!activeModal) return;
        activeModal.classList.remove('is-active');
        activeModal.hidden = true;
        layer.classList.remove('is-open');
        layer.hidden = true;
        unlockPageScroll();
        if (activeTrigger && activeTrigger.focus) activeTrigger.focus();
        activeModal = null;
        activeTrigger = null;
      }

      function openModal(key, trigger) {
        if (!renderModal(key)) return;
        ensureLayerInBody();

        if (activeModal) {
          activeModal.classList.remove('is-active');
          activeModal.hidden = true;
        }
        activeModal = modal;
        activeTrigger = trigger;
        layer.hidden = false;
        modal.hidden = false;
        lockPageScroll();

        window.requestAnimationFrame(function () {
          layer.classList.add('is-open');
          modal.classList.add('is-active');
          var focusable = getFocusable(modal);
          if (focusable.length) focusable[0].focus();
        });
      }

      Array.prototype.forEach.call(triggers, function (trigger) {
        trigger.addEventListener('pointerdown', function (event) {
          event.stopPropagation();
        });

        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          openModal(trigger.getAttribute('data-ohow-insight-modal-trigger'), trigger);
        });
      });

      layer.addEventListener('click', function (event) {
        if (event.target === layer || event.target.closest('[data-ohow-insight-modal-close]')) {
          closeModal();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (!activeModal) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal();
          return;
        }
        if (event.key !== 'Tab') return;

        var focusable = getFocusable(activeModal);
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    });
  }

  function initHowAccuracy(root) {
    var accordions = (root || document).querySelectorAll('[data-ohow-accuracy]');
    if (!accordions.length && root && root.matches && root.matches('[data-ohow-accuracy]')) accordions = [root];

    Array.prototype.forEach.call(accordions, function (accordion) {
      if (!accordion || accordion.dataset.ohowAccuracyReady === 'true') return;
      accordion.dataset.ohowAccuracyReady = 'true';

      var items = Array.prototype.slice.call(accordion.querySelectorAll('[data-ohow-accuracy-item]'));
      var duration = parseInt(accordion.getAttribute('data-ohow-accuracy-duration'), 10) || 10000;
      var activeIndex = Math.max(0, items.findIndex(function (item) {
        return item.classList.contains('ohow-accuracy-item--open');
      }));
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var cardAnimationDuration = 420;
      var cardAnimationEase = 'cubic-bezier(0.33, 1, 0.68, 1)';
      var frameId = 0;
      var startedAt = 0;

      function setProgress(item, value) {
        item.style.setProperty('--ohow-accuracy-progress', Math.max(0, Math.min(1, value)));
      }

      function stopTimer() {
        if (frameId) window.cancelAnimationFrame(frameId);
        frameId = 0;
      }

      function tick(now) {
        if (!startedAt) startedAt = now;
        var activeItem = items[activeIndex];
        var progress = Math.min(1, (now - startedAt) / duration);
        if (activeItem) setProgress(activeItem, progress);

        if (progress >= 1) {
          setActive((activeIndex + 1) % items.length, true);
          return;
        }

        frameId = window.requestAnimationFrame(tick);
      }

      function startTimer() {
        stopTimer();
        startedAt = 0;
        if (items.length < 2) return;
        frameId = window.requestAnimationFrame(tick);
      }

      function setActive(index, shouldAnimate) {
        activeIndex = Math.max(0, Math.min(items.length - 1, index));
        var states = items.map(function (item, itemIndex) {
          var trigger = item.querySelector('[data-ohow-accuracy-trigger]');
          var panel = item.querySelector('[data-ohow-accuracy-panel]');
          var isActive = itemIndex === activeIndex;
          var style = window.getComputedStyle(item);

          if (trigger) trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');

          return {
            item: item,
            panel: panel,
            isActive: isActive,
            wasOpen: item.classList.contains('ohow-accuracy-item--open'),
            firstRect: item.getBoundingClientRect(),
            firstRadius: style.borderRadius,
            contentY: style.getPropertyValue('--ohow-accuracy-content-y').trim() || '24px'
          };
        });
        var canAnimate = shouldAnimate && !reduceMotion && states.every(function (state) {
          return state.item.animate && (!state.panel || state.panel.animate);
        });

        states.forEach(function (state) {
          if (state.item._ohowAccuracyCleanup) window.clearTimeout(state.item._ohowAccuracyCleanup);
          if (state.item._ohowAccuracyAnimation) {
            state.item._ohowAccuracyAnimation.cancel();
            state.item._ohowAccuracyAnimation = null;
          }
          if (state.panel && state.panel._ohowAccuracyAnimation) {
            state.panel._ohowAccuracyAnimation.cancel();
            state.panel._ohowAccuracyAnimation = null;
          }
          state.item.style.width = '';
          state.item.style.height = '';
          state.item.style.minHeight = '';
        });

        if (!canAnimate) {
          states.forEach(function (state) {
            if (state.panel) state.panel.hidden = !state.isActive;
            state.item.classList.toggle('ohow-accuracy-item--open', state.isActive);
            state.item.classList.remove('ohow-accuracy-item--closing');
            setProgress(state.item, 0);
          });
          startTimer();
          return;
        }

        states.forEach(function (state) {
          if (state.panel) state.panel.hidden = !state.isActive;
          state.item.classList.remove('ohow-accuracy-item--closing');
          state.item.classList.toggle('ohow-accuracy-item--open', state.isActive);
        });

        states.forEach(function (state) {
          state.targetRect = state.item.getBoundingClientRect();
          state.targetRadius = window.getComputedStyle(state.item).borderRadius;
        });

        states.forEach(function (state) {
          if (state.panel) state.panel.hidden = !(state.isActive || state.wasOpen);
          state.item.classList.toggle('ohow-accuracy-item--open', state.isActive);
          state.item.classList.toggle('ohow-accuracy-item--closing', state.wasOpen && !state.isActive);
          setProgress(state.item, 0);

          state.item._ohowAccuracyAnimation = state.item.animate([
            {
              width: state.firstRect.width + 'px',
              height: state.firstRect.height + 'px',
              minHeight: state.firstRect.height + 'px',
              borderRadius: state.firstRadius
            },
            {
              width: state.targetRect.width + 'px',
              height: state.targetRect.height + 'px',
              minHeight: state.targetRect.height + 'px',
              borderRadius: state.targetRadius
            }
          ], {
            duration: cardAnimationDuration,
            easing: cardAnimationEase,
            fill: 'both'
          });

          state.item._ohowAccuracyAnimation.addEventListener('finish', function () {
            if (state.panel) state.panel.hidden = !state.isActive;
            state.item.classList.toggle('ohow-accuracy-item--open', state.isActive);
            state.item.classList.remove('ohow-accuracy-item--closing');
            state.item.style.width = '';
            state.item.style.height = '';
            state.item.style.minHeight = '';
            if (state.item._ohowAccuracyAnimation) {
              state.item._ohowAccuracyAnimation.cancel();
              state.item._ohowAccuracyAnimation = null;
            }
          }, { once: true });

          if (state.panel && state.isActive) {
            state.panel._ohowAccuracyAnimation = state.panel.animate([
              { opacity: 0, transform: 'translate3d(0, ' + state.contentY + ', 0)' },
              { opacity: 1, transform: 'translate3d(0, 0, 0)' }
            ], {
              duration: 600,
              delay: 250,
              easing: 'ease-in-out',
              fill: 'both'
            });
          } else if (state.panel && state.wasOpen) {
            state.panel._ohowAccuracyAnimation = state.panel.animate([
              { opacity: 1, transform: 'translate3d(0, 0, 0)' },
              { opacity: 0, transform: 'translate3d(0, ' + state.contentY + ', 0)' }
            ], {
              duration: 300,
              easing: 'ease-in-out',
              fill: 'both'
            });
          }
        });

        startTimer();
      }

      Array.prototype.forEach.call(items, function (item, index) {
        var trigger = item.querySelector('[data-ohow-accuracy-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          setActive(index, true);
        });
      });

      if (items.length) setActive(activeIndex, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initHowHeroParallax(document);
      initHowNav(document);
      initHowSteps(document);
      initHowInsightScroll(document);
      initHowInsightModal(document);
      initHowAccuracy(document);
    });
  } else {
    initHowHeroParallax(document);
    initHowNav(document);
    initHowSteps(document);
    initHowInsightScroll(document);
    initHowInsightModal(document);
    initHowAccuracy(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initHowHeroParallax(event.target);
    initHowNav(event.target);
    initHowSteps(event.target);
    initHowInsightScroll(event.target);
    initHowInsightModal(event.target);
    initHowAccuracy(event.target);
  });
})();
